import Progress1 from '../components/SVG/Progress1';
import Progress2 from '../components/SVG/Progress2';
import Progress3 from '../components/SVG/Progress3';
import Progress4 from '../components/SVG/Progress4';
import Progress5 from '../components/SVG/Progress5';
import Progress6 from '../components/SVG/Progress6';
import Progress7 from '../components/SVG/Progress7';
import Progress8 from '../components/SVG/Progress8';
import Progress9 from '../components/SVG/Progress9';
import Progress10 from '../components/SVG/Progress10';
import Progress11 from '../components/SVG/Progress11';
import Progress12 from '../components/SVG/Progress12';
import Progress13 from '../components/SVG/Progress13';
import Progress14 from '../components/SVG/Progress14';
import Progress15 from '../components/SVG/Progress15';
import Progress15a from '../components/SVG/Progress15a';
import Progress16 from '../components/SVG/Progress16';
import Progress17 from '../components/SVG/Progress17';
import Progress18 from '../components/SVG/Progress18';
import Progress19 from '../components/SVG/Progress19';
import Progress20 from '../components/SVG/Progress20';
import Progress21 from '../components/SVG/Progress21';
import Progress22 from '../components/SVG/Progress22';
import Progress23 from '../components/SVG/Progress23';
import Progress24 from '../components/SVG/Progress24';
import Progress25 from '../components/SVG/Progress25';
import Progress26 from '../components/SVG/Progress26';
import Progress27 from '../components/SVG/Progress27';
import Progress28 from '../components/SVG/Progress28';
import Progress29 from '../components/SVG/Progress29';
import Progress30 from '../components/SVG/Progress30';
import Progress31 from '../components/SVG/Progress31';
import Progress32 from '../components/SVG/Progress32';
import Progress33 from '../components/SVG/Progress33';
import Progress34 from '../components/SVG/Progress34';

export default {
  '/warto-by-tu-troche-posprzatac': Progress1,
  '/czym-jest-programowanie': Progress2,
  '/jak-wyglada-linijka-kodu': Progress3,
  '/sterowanie-skribotem': Progress4,
  '/pierwsze-zadanie': Progress5,
  '/ile-butelek-pet-potrzeba-do-produkcji-bluzy': Progress6,
  '/uzupelnij-brakujace-funkcje': Progress7,
  '/algorytm': Progress8,
  '/dolacza-drugi-skribot': Progress9,
  '/czy-wiesz': Progress10,
  '/to-logiczne': Progress11,
  '/true-or-false': Progress12,
  '/parametr-wyjsciowy': Progress13,
  '/czas-na-decyzje': Progress14,
  '/instrukcja-warunkowa': Progress16,
  '/znak-graficzny-PET': Progress15,
  '/a-co-jesli': Progress15a,
  '/wiecej-warunkow': Progress17,
  '/i-co-teraz-z-tymi-odpadami': Progress18,
  '/wyrazene-warunkowe': Progress19,
  '/co-wrzucamy-do-zoltego-pojemnika': Progress20,
  '/obiekt-programistyczny': Progress21,
  '/proces-segregacji': Progress22,
  '/skribot-na-tasmie': Progress23,
  '/skribot-na-tasmie-zadanie': Progress24,
  '/skribot-na-tasmie-drugie-zadanie': Progress25,
  '/operacje-na-wyrazeniach-logicznych': Progress26,
  '/true-or-false-quiz': Progress27,
  '/skribot-na-tasmie-trzecie-zadanie' : Progress28,
  '/dwa-skriboty-na-tasmie': Progress29,
  '/petla-while': Progress30,
  '/wielki-powrot-butelki' : Progress31,
  '/do-mlynka': Progress32,
  '/dziel-i-myj': Progress33,
  '/drugie-zycie-butelki-pet': Progress34
};



// WEBPACK FOOTER //
// ./src/config/progress.js